import { render, staticRenderFns } from "./ChartPropModal.vue?vue&type=template&id=acd8f65a&scoped=true"
import script from "./ChartPropModal.vue?vue&type=script&lang=js"
export * from "./ChartPropModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acd8f65a",
  null
  
)

export default component.exports